import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { SessionService } from '../../../Util/Session/session.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { EmployeeReportingToService } from '../../../Model/ReportingToService/employee-reporting-to.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { CommonService } from '../../../Model/Common/common.service';

@Component({
  selector: 'app-company-head',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, DataTablesModule],
  templateUrl: './company-head.component.html',
  styleUrl: './company-head.component.scss'
})
export class CompanyHeadComponent {
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  public User: any = null;
  UserLoad: any[] = [];
  CompanyLoad : any[] = [];
  dtoptions: DataTables.Settings = {};
  constructor(
    private sessionService: SessionService,
    private comboload: ComboService,
    private toast: ToastService,
    private modalService: NgbModal,
    private EmployeeService: EmployeeReportingToService,
    protected common:CommonService
  ) { 
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('GetEssUserMaster');
    this.GetData();
  }
  
  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.comboload.ComboLoad({
      'Combotype': Combotype,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'GetEssUserMaster') {
          this.UserLoad = response.ComboLoad; 
        }
      },
      complete: () => {
      },
      error: (error) => {
      },  
    });
  }

  GetData(){
    const ReportingToData = {
      SelectType: 'GetEssCompanyMaster'
    }
    this.EmployeeService.EmployeeReportingToSelect(ReportingToData).subscribe(
      data => {
        this.CompanyLoad = Object.values(data.Table);
        this.isDisabled = false;
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false
      }
    );
  }
  async save(){
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.Message = 'Are you Sure want to save?'

    modalRef.result.then((result: any) => {
      if (result) {
        if(this.common.PageRight.IsEdit){
          this.Update();
        }
      }
    }).catch(() => {

    });
  }

  Update() {
    if (this.CompanyLoad.length === 0) {
      this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
      return
    }
    this.User = this.sessionService.GetUserDetails();
    const site = this.CompanyLoad[0];
    const ReportData = {
      SelectType: 'Update',
      CompanyMasterID: site.CompanyMasterID,
      CompanyOwnerID : site.CompanyOwnerId,
      UserId: this.User.UserId
    }
    this.isDisabled = true;
    this.EmployeeService.ReportingToCompany(ReportData).subscribe(
      data => {
        if (data.Error_Code == 1) {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
          this.CompanyLoad = []
        }
        else {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.warning });
        }
        this.GetData();
        this.isDisabled = false;
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      });
  }
}
